import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { Button } from '#app/components/base/buttons/button.js'
import { authClient } from '#app/lib/auth.client.js'
import { trpc } from '#app/lib/trpc-tanstack.tsx'

export function ImpersonationBanner() {
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const { data: user } = useQuery(trpc.user.getCurrent.queryOptions())

	const stopImpersonatingMutation = useMutation({
		mutationFn: async () => {
			const result = await authClient.admin.stopImpersonating()
			if (result.error) throw result.error
			return result.data
		},
		onSuccess: () => {
			void queryClient.invalidateQueries()
			void navigate('/admin/users')
		},
		onError: (error) => {
			console.error('Failed to stop impersonating:', error)
		},
	})

	if (!user?.impersonatedBy) {
		return null
	}

	return (
		<div className="bg-warning-primary fixed top-0 right-0 left-0 z-50 flex items-center justify-center gap-4 px-4 py-2">
			<span className="text-warning-primary text-sm font-medium">
				You are impersonating {user.name} ({user.email})
			</span>
			<Button
				size="sm"
				color="tertiary"
				onClick={() => stopImpersonatingMutation.mutate()}
				isLoading={stopImpersonatingMutation.isPending}
			>
				Stop Impersonating
			</Button>
		</div>
	)
}
